export const CASE_STATUS = {
    REPORT_GENERATED : 'Report Generated'
}